import FooterComponent from "slotworks/components/footer/footer-component";
import Layers from "slotworks/graphics/layers/layers";
import Idle from "slotworks/state-machine/standard/states/idle";
import sgWildsComponent from "components/wilds/sg-wilds-component";
import Timer from "slotworks/utils/timer";
import { Services } from "slotworks/services/services";
import sgSandAnimation from "components/sg-sand-animation";

export default class SGIdle extends Idle {

    private timeout: number;
    public onEnter() {
        let text = Layers.BetBar.getFlexiText("total_stake_stepper_value");
        if (text) {
            text.setAutoResize(true);
        }

        text = FooterComponent.layer.getFlexiText("value");

        if (text) {
            text.setAutoResize(true);
        }

        this.timeout = Timer.setTimeout(() => {
            Services.sound.customEvent("base_game_idle");
        }, 3000);

        sgSandAnimation.stopSandAnimation();

        super.onEnter();
    }
    public onExit() {
        Timer.clearTimeout(this.timeout);
        super.onExit();
    }

    public onSkip() {
        Timer.clearTimeout(this.timeout);
        super.onSkip();
    }
}
